@if (form) {
    @switch (currentSettings()) {
        @case (settingEnum.main) {
            @let productSettings = form.productSettings().value();
            @let paymentElements = form.paymentElements().value();
            @let dealName = form.dealName().value();
            @let addCrmTags = form.addCrmTags().value();
            @let contactTags = form.contactTags().value();
            @let addAddressBookTags = form.addAddressBookTags().value();
            @let bookTags = form.contactAddressBookTags().value();
            @let elements = form.elements().value();
            @let modalTextHint = form.modalTextHint().value();
            @let inputSettings = form.inputSettings().value();
            @let formButtonSettings = form.formButtonSettings().value();

            <web-widget-breadcrumbs
                [widget]="widget()"
                [hideBreadcrumbs]="isZero()"
                [isInSpecificSection]="isSpecific()"
                [isEduSite]="isEduSite()"
            />

            <div class="panel-options-body overflow-wrapper">
                <web-paid-access-notification-container [widgetName]="widget().name" />
                <div class="form-group mb-0" [class.has-error]="form.paymentFormName().invalid()">
                    <label>
                        {{ "control_order_form_name" | translate }}
                    </label>
                    <input class="form-control" type="text" [formField]="form.paymentFormName" />
                    @if (form.paymentFormName().value()) {
                        <span class="help-block small">
                            {{ "control_displayed_on_order_form" | translate }}
                        </span>
                    } @else {
                        <span class="help-block small">
                            {{ "control_errors_required" | translate }}
                        </span>
                    }
                </div>
                <div class="form-group mb-10">
                    <label>
                        {{ "control_product" | translate }}
                    </label>
                    <select class="form-control" (change)="changeProductType($event)">
                        <option [selected]="isProductTypeDefault()" [value]="productTypeEnum.default">
                            {{ "control_select_new_product" | translate }}
                        </option>
                        <option
                            [selected]="isProductTypeEduCourse()"
                            [value]="productTypeEnum.eduCourse"
                            [disabled]="isEduCoursesEmpty$ | async"
                        >
                            {{ "control_select_edu_course" | translate }}
                        </option>
                    </select>
                </div>
                @if (isProductTypeDefault()) {
                    <div class="form-group mb-0" [class.has-error]="form.productName().invalid()">
                        <input class="form-control" type="text" [formField]="form.productName" />
                        @if (form.productName().value()) {
                            <span class="help-block small">
                                {{ "control_displayed_on_payment" | translate }}
                            </span>
                        } @else {
                            <span class="help-block small">
                                {{ "control_errors_required" | translate }}
                            </span>
                        }
                    </div>
                }
                @if (isProductTypeEduCourse()) {
                    <div class="form-group mb-20">
                        @let eduCourses = eduCourses$ | async;
                        <web-course-tariff-selector
                            [selectedCourse]="productSettings?.courseId"
                            [selectedTariffId]="productSettings?.courseTariffId"
                            [isDisabled]="!eduCourses?.length"
                            [paid]="'paid'"
                            (selectionChange)="setEduCourseToProduct($event)"
                        />
                        @if (productSettings?.isPaid) {
                            <span class="help-block small">
                                {{ "control_displayed_on_payment" | translate }}
                            </span>
                        }
                    </div>
                    <web-edu-course-payments-collection
                        [courseId]="productSettings?.courseId"
                        [courseTariffId]="productSettings?.courseTariffId"
                        [coursePayments$]="eduCoursePaymentsDynamic$"
                        [coursePaymentsStatuses$]="eduCoursePaymentsStatusesDynamic$"
                        [paymentElements]="paymentElements"
                        (setSkipHistoryEvent)="setSkipHistory()"
                        (setPaymentElementsEvent)="setPaymentElements($event)"
                    />
                }
                @if (isProductTypeDefault()) {
                    <web-payment-methods-signal-collection
                        [paymentMethods]="paymentMethods()"
                        [isLoading]="paymentMethodsQuery.isLoading()"
                        [isFailure]="paymentMethodsQuery.isError()"
                        [paymentElements]="paymentElements"
                        (editActionEvent)="editPaymentElement($event)"
                        (setSkipHistoryEvent)="setSkipHistory()"
                        (setPaymentElementsEvent)="setPaymentElements($event)"
                    />
                }
                <hr class="panel-options-divider" />
                @if (isCrmDisabled()) {
                    <div class="alert alert-warning">
                        <a href="/crm/deals" target="_blank"
                            >{{ "crm_not_initialized_link" | translate }}
                            <img class="font-icon" src="./assets/img/websites/lpc-new-window-icon.svg" alt="icon" />
                        </a>
                        {{ "crm_not_initialized_text" | translate }}
                    </div>
                } @else {
                    @if (isProductTypeDefault()) {
                        <div class="form-group mb-20" [class.has-error]="form.dealName().errors().length">
                            <label>
                                {{ "crm_deal_name" | translate }}
                            </label>
                            <input
                                class="form-control"
                                type="text"
                                [value]="dealName ?? ''"
                                (input)="form.setDealName($any($event.target).value)"
                            />
                            @if (form.dealName().errors().length) {
                                <span class="help-block small">
                                    {{ "control_errors_required" | translate }}
                                </span>
                            }
                        </div>
                        <web-crm-pipelines-collection
                            [selectedPipeline]="form.selectedPipeline().value() ?? null"
                            [selectedPipelineStep]="form.selectedPipelineStep().value() ?? null"
                            [isCrmDisabled]="isCrmDisabled()"
                            [crmPipelines]="crmPipelines()"
                            [isLoading]="crmPipelinesQuery.isLoading()"
                            [isError]="crmPipelinesQuery.isError()"
                            (setSkipHistoryEvent)="setSkipHistory()"
                            (selectedPipelineChange)="setPipeline($event)"
                        />
                        <div class="mb-10">
                            <div class="form-group form-horizontal row mb-10">
                                <label class="control-label col-xs-9">
                                    {{ "add_tags_crm" | translate }}
                                </label>
                                <div class="col-xs-3 control-switch text-right">
                                    <sp-switch
                                        [active]="form.addCrmTags().value()"
                                        (toggleActiveEvent)="toggleAddCrmTags($event)"
                                    ></sp-switch>
                                </div>
                            </div>
                            @if (addCrmTags) {
                                <web-tags-collection
                                    [selected]="contactTags ?? []"
                                    (selectedChange)="form.setContactTags($event)"
                                    [tags]="crmTags()"
                                    [isLoading]="crmTagsQuery.isPending()"
                                    [isError]="crmTagsQuery.isError()"
                                />
                            }
                        </div>
                        <div>
                            <div class="form-group form-horizontal row">
                                <label class="control-label col-xs-9">
                                    {{ "add_address_book" | translate }}
                                </label>
                                <div class="col-xs-3 control-switch text-right">
                                    <sp-switch
                                        [active]="form.createAddressBook().value()"
                                        (toggleActiveEvent)="toggleAddressBookSettings($event)"
                                    />
                                </div>
                            </div>
                            @if (form.createAddressBook().value()) {
                                <sp-address-books-ui
                                    [data]="addressBooksQuery.data() ?? []"
                                    [isLoading]="addressBooksQuery.isPending()"
                                    [isError]="addressBooksQuery.isError()"
                                    [selected]="form.selectedAddressBook().value() ?? null"
                                    (selectedChange)="onSelectedAddressBookChange($event)"
                                    showContactHint
                                />
                            }
                        </div>
                        @if (form.createAddressBook().value() && form.selectedAddressBook().value()) {
                            <div class="well well-sm" style="margin-top: -15px">
                                <div class="form-group form-horizontal row mb-10">
                                    <label class="control-label col-xs-9">
                                        {{ "add_tags_address_book" | translate }}
                                    </label>
                                    <div class="col-xs-3 control-switch text-right">
                                        <sp-switch
                                            [active]="addAddressBookTags"
                                            (toggleActiveEvent)="toggleAddAddressBookTags($event)"
                                        ></sp-switch>
                                    </div>
                                </div>

                                @if (addAddressBookTags) {
                                    <web-tags-collection
                                        [selected]="bookTags ?? []"
                                        (selectedChange)="form.setContactAddressBookTags($event)"
                                        [tags]="addressBooksTags()"
                                        [isLoading]="addressBooksTagsQuery.isPending()"
                                        [isError]="addressBooksTagsQuery.isError()"
                                    />
                                }
                            </div>
                        }
                        <hr class="panel-options-divider" />
                    }
                }
                @if (!isSpecific()) {
                    <div class="form-group row mb-20">
                        <div class="col-xs-12">
                            <label>
                                {{ "control_view" | translate }}
                            </label>
                            <a class="dotted pull-right" (click)="setCurrentSettingsType(settingEnum.input)">
                                {{ "control_form_fields_styles" | translate }}
                            </a>
                        </div>
                        <div class="col-xs-12">
                            <div class="appearance-wrapper">
                                <div
                                    class="appearance-block"
                                    [class.active]="form.formView().value() === EPaymentView.static"
                                    [tooltip]="staticForm"
                                    (click)="form.setFormView(EPaymentView.static)"
                                >
                                    <img src="./assets/img/websites/lpc-static-form-icon.svg" alt="static form" />
                                    <ng-template #staticForm>
                                        {{ "control_static_form_tooltip" | translate }}
                                    </ng-template>
                                </div>
                                <div
                                    class="appearance-block"
                                    [class.active]="form.formView().value() === EPaymentView.modal"
                                    [tooltip]="modalForm"
                                    (click)="form.setFormView(EPaymentView.modal)"
                                >
                                    <img src="./assets/img/websites/lpc-modal-form-icon.svg" alt="modal form" />
                                    <ng-template #modalForm>
                                        {{ "control_modal_form_tooltip" | translate }}
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div
                    class="mb-20"
                    cdkDropList
                    [cdkDropListData]="elements"
                    (cdkDropListDropped)="dropElementItem($event)"
                >
                    <div>
                        <label>
                            {{ "control_form_fields" | translate }}
                        </label>
                        @if (isSpecific()) {
                            <a class="dotted pull-right" (click)="setCurrentSettingsType(settingEnum.input)">
                                {{ "control_form_fields_styles" | translate }}
                            </a>
                        }
                    </div>
                    @for (input of elements; track $index; let i = $index) {
                        <div cdkDrag cdkDropListGroup [cdkDragData]="input">
                            <sp-control-handle
                                [controlHandleBtn]="elements.length === 1 ? false : true"
                                [controlHandleDisableDelete]="!!input.protected"
                                [controlHandleMainText]="input.label | spHtmlToText"
                                [controlHandleIcon]="getControlHandleIcon(input.type)"
                                (removeActionEvent)="removeInput(i)"
                                (editActionEvent)="editInput(i)"
                            >
                                <span cdkDragHandle></span>
                                <ng-template #variablesTemplate>
                                    <sp-variables-popover
                                        [element]="$any(input)"
                                        [addressBookVariablesList]="
                                            addressBookVariablesById(form.selectedAddressBook().value())
                                        "
                                        [crmContactsVariablesList]="crmContacts()"
                                        [crmDealsVariablesList]="crmDeals()"
                                        [createAddressBook]="form.createAddressBook().value()"
                                        [isCrmDealsListDisabled]="isProductTypeEduCourse()"
                                    />
                                </ng-template>
                            </sp-control-handle>
                        </div>
                    }
                    <a class="dotted" (click)="addInput()">
                        {{ "add" | translate }}
                    </a>
                </div>
                <div class="mb-20">
                    <label>
                        {{ "form_button" | translate }}
                    </label>
                    <sp-control-handle
                        [controlHandleMainText]="formButtonSettings.label"
                        (editActionEvent)="setCurrentSettingsType(settingEnum.button)"
                    />
                </div>
                <div class="mb-20">
                    <div class="form-group form-horizontal row">
                        <label class="control-label col-xs-9">
                            {{ "add_modal_text_hint" | translate }}
                            <span
                                class="small sp-icon icon-question color-light hover-effect"
                                [tooltip]="'modal_text_hint' | translate"
                                [placement]="'top'"
                                [adaptivePosition]="false"
                                triggers="mouseover:mouseleave"
                            ></span>
                        </label>
                        <div class="col-xs-3 control-switch text-right">
                            <sp-switch
                                [active]="modalTextHint !== null"
                                (toggleActiveEvent)="toggleModalTextHint($event)"
                            />
                        </div>
                    </div>
                    @if (modalTextHint !== null) {
                        <div class="form-group">
                            <web-editor
                                class="sp-editor form-control checkbox-textarea"
                                [toolbarMenu]="'link forecolor backcolor'"
                                [placeholder]="'input_modal_text_hint' | translate"
                                [content]="modalTextHint"
                                (changeContent)="form.setModalTextHint($event)"
                            />
                        </div>
                    }
                </div>
                @if (!isSpecific()) {
                    <div class="mb-20">
                        <div class="form-group form-horizontal row">
                            <label class="control-label col-xs-6">
                                {{ "control_align_content" | translate }}
                            </label>
                            <div class="col-xs-6">
                                <sp-radio-group
                                    [selected]="inputSettings.horizontalPosition"
                                    [type]="radioGroupType.horizontalPosition"
                                    (changeSelectedEvent)="setInputSettingsHorizontalPosition($event)"
                                />
                            </div>
                        </div>
                    </div>
                }
                <div class="form-group mb-10 mt-20">
                    <div class="device-toggle-wrapper">
                        <web-device-toggle />
                        @if (!isZero()) {
                            <web-synchronize-style-toggle
                                [active]="form.isSynchronizeStyle().value()"
                                (click)="form.setIsSynchronizeStyle(!form.isSynchronizeStyle().value())"
                            />
                        }
                    </div>
                </div>

                <div class="form-group mb-0">
                    @if (isDeviceDesktop()) {
                        <p class="help-block text-muted small">
                            {{ "desktop_device_hint" | translate }}
                        </p>
                    }
                    @if (isDeviceTablet()) {
                        <p class="help-block text-muted small">
                            {{ "tablet_device_hint" | translate }}
                        </p>
                    }
                    @if (isDeviceMobile()) {
                        <p class="help-block text-muted small">
                            {{ "mobile_device_hint" | translate }}
                        </p>
                    }
                </div>

                @if (isZero()) {
                    <div class="form mt-10 mb-20 form-horizontal">
                        <sp-extended-position-signal-settings
                            [position]="zeroForm.position().value()"
                            [isMobile]="isDeviceMobile()"
                            [isTablet]="isDeviceTablet()"
                            [parentId]="form.columnId().value()"
                            (valueChangeEvent)="zeroForm.setPosition($event)"
                        />
                    </div>
                } @else {
                    <div class="form mt-10 mb-20 form-horizontal">
                        <web-widget-position-settings
                            [isTablet]="isDeviceTablet()"
                            [isMobile]="isDeviceMobile()"
                            [isSynchronized]="form.isSynchronizeStyle().value()"
                            [widgetId]="form.id().value()"
                            [columnId]="form.columnId().value()"
                            [position]="defaultForm.position().value()"
                            (positionChange)="onPositionChange($event)"
                        />
                    </div>
                }
                <hr class="panel-options-divider" />
                <div class="form mt-20 mb-20 form-horizontal">
                    @if (isZero()) {
                        <web-widget-extended-hide-settings
                            [hideOnDesktop]="form.hideOnDesktop().value()"
                            [hideOnTablet]="form.hideOnTablet().value()"
                            [hideOnMobile]="form.hideOnMobile().value()"
                            (hideOnDesktopChange)="form.setHideOnDesktop($event)"
                            (hideOnTabletChange)="form.setHideOnTablet($event)"
                            (hideOnMobileChange)="form.setHideOnMobile($event)"
                        />
                    } @else {
                        <web-widget-hide-settings
                            [hideOnDesktop]="form.hideOnDesktop().value()"
                            [hideOnTablet]="form.hideOnTablet().value()"
                            [hideOnMobile]="form.hideOnMobile().value()"
                            (hideOnDesktopChange)="form.setHideOnDesktop($event)"
                            (hideOnTabletChange)="form.setHideOnTablet($event)"
                            (hideOnMobileChange)="form.setHideOnMobile($event)"
                        />
                    }
                </div>
                <hr class="panel-options-divider" />
                @if (!isProductTypeEduCourse()) {
                    <div class="mb-20">
                        <a class="dotted" (click)="setCurrentSettingsType(settingEnum.additional)">
                            {{ "additional_form_settings" | translate }}
                        </a>
                    </div>
                }
                <a class="dotted" (click)="setCurrentSettingsType(settingEnum.analytics)">
                    {{ "analytics_form_settings" | translate }}
                </a>
                <div class="mt-20">
                    <web-custom-id [displayId]="form.displayId()" (valueChangeEvent)="form.setDisplayId($event)" />
                </div>
            </div>
        }
        @case (settingEnum.button) {
            <web-payment-button-settings [form]="form" (saveEvent)="closeSettings()" (cancelEvent)="closeSettings()" />
        }
        @case (settingEnum.element) {
            <web-payment-element-settings
                [form]="form"
                [index]="editingInputIndex() ?? 0"
                [crmContactsVariablesList]="crmContacts()"
                [crmDealsVariablesList]="crmDeals()"
                [addressBookVariablesList]="addressBookVariablesById(form.selectedAddressBook().value())"
                [filteredFormControls]="filteredFormControls"
                [isFormControlDisabled]="isFormControlDisabled()"
                [isAddressBookListDisabled]="isAddressBookListDisabled()"
                [isCrmDealsListDisabled]="isCrmDealsListDisabled()"
                [isCrmContactListDisabled]="isCrmContactListDisabled()"
                [isPaymentEduForm]="isProductTypeEduCourse()"
                (saveEvent)="closeSettings()"
                (cancelEvent)="closeSettings()"
            />
        }
        @case (settingEnum.input) {
            <web-payment-input-settings
                [form]="form"
                [formView]="$any(form.formView().value())"
                (saveEvent)="closeSettings()"
                (cancelEvent)="closeSettings()"
            />
        }
        @case (settingEnum.additional) {
            <web-payment-additional-settings
                [form]="form"
                [isHasSuccessPageOption]="isHasSuccessPage()"
                (saveEvent)="closeSettings()"
                (cancelEvent)="closeSettings()"
            />
        }
        @case (settingEnum.payment) {
            <web-payment-method-settings
                [form]="form"
                [index]="editingInputIndex() ?? 0"
                [paymentMethods]="paymentMethods()"
                (saveEvent)="closeSettings()"
                (cancelEvent)="closeSettings()"
            />
        }
        @case (settingEnum.analytics) {
            <web-analytics-settings-signal-legacy
                [settings]="form.analyticsSettings().value() ?? null"
                [pixelAnalyticType]="EPixelTypes.purchase"
                (valueChangeEvent)="form.setAnalyticsSettings($event)"
                (cancelEvent)="closeSettings()"
            />
        }
    }
}
